import React from 'react';
import { formatWithCommas, formatDate } from '@perch-labs/warbler';
import { copyFor } from 'config';
import { InvisibleTable } from 'styles';

const getCopy = copyFor('solar.stateStats.statsMap.invisibleTable');

type Props = {
  projectData?: GetVnmSolarProjectsByStateQuery['vnmSolarProjectsByState'];
  vnmSolarProjectId?: number;
};

export const InvisibleMapTable = ({
  projectData,
  vnmSolarProjectId,
}: Props) => {
  const getName = datum =>
    datum.id === vnmSolarProjectId
      ? getCopy('yourFarm', { name: datum.name })
      : datum.name;

  return (
    <div>
      <InvisibleTable>
        <caption>{getCopy('title')}</caption>
        <thead>
          <tr>
            <th scope="col">{getCopy('farmName')}</th>
            <th scope="col">{getCopy('kwh')}</th>
            <th scope="col">{getCopy('startDate')}</th>
          </tr>
        </thead>
        <tbody>
          {projectData?.map(datum => (
            <tr key={datum.id}>
              <th scope="row">{getName(datum)}</th>
              <td>{formatWithCommas(datum.totalCapacity)}</td>
              <td>{formatDate(datum.startDate, { format: 'MMMM do yyyy' })}</td>
            </tr>
          ))}
        </tbody>
      </InvisibleTable>
    </div>
  );
};
